
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 9.021a1.725 1.725 0 01-.585 1.297l-8.364 7.358a1.385 1.385 0 01-1.829-2.08l7.314-6.434a.187.187 0 000-.282L1.222 2.446a1.385 1.385 0 111.83-2.08l8.36 7.356a1.73 1.73 0 01.588 1.3z","fill":"#797C86"}})])
          )
        }
      }
    